import React from "react";
import styles from "./styles.module.css";
export default function Checkbox(props) {
    return (
        <div>
            <input type="checkbox" className={ styles.checkbox } {...props} />
            <label for={props.label}>{props.label}</label>
        </div>
    )
}